import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ArticleApi } from '../../../network';
import { ArticleModel } from '../../../network/rest';
import ApiErrorHandler from '../../../utils/ApiErrorHandler';
import { translations } from '../../../utils/staticContent';
import ListItemWithDescription from '../../components/ListItemWithDescription';
import Pagination from '../../components/Pagination';
import './style.scss';

function Articles() {
    const [data, setData] = useState<ArticleModel[]>([]);
    const [searchParams] = useSearchParams();
    const [dataCount, setDataCount] = useState(0);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10,
    });

    async function getData() {
        try {
            const response = await ArticleApi.getArticlesApiV1ArticlesGet({
                offset: controller.page * controller.rowsPerPage,
                limit: controller.rowsPerPage,
                search: searchQuery || '',
            });
            if (response) {
                setData(response.articles);
                setDataCount(response.total);
            }
        } catch (e) {
            ApiErrorHandler(e, true);
        }
    }

    const searchQuery = searchParams.get('search');
    const previousSearchQuery = useRef(searchQuery);

    useEffect(() => {
        const isNewSearch = previousSearchQuery.current !== searchQuery;
        previousSearchQuery.current = searchQuery;

        // a new search invalidates the current offset, so go back to the first
        // page and let that controller change trigger the fetch
        if (isNewSearch && controller.page !== 0) {
            handlePageChange(0);
            return;
        }

        getData();
    }, [controller, searchQuery]);

    function handlePageChange(newPage: number) {
        setController({
            ...controller,
            page: newPage,
        });
    }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0,
        });
    };

    return (
        <div className="News">
            <h1>{translations.articles}</h1>
            {data.map((news, idx) => (
                <ListItemWithDescription key={`${news.title}${idx}`} data={news} />
            ))}
            <Pagination
                page={controller.page}
                count={dataCount}
                rowsPerPage={controller.rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </div>
    );
}

export default Articles;
